<template>
  <div class="uk-container uk-container-expand">
    <div class="uk-grid uk-child-width-1-1" data-uk-grid>
      <div>
        <div class="uk-flex uk-flex-between uk-flex-middle">
          <div>
            <h3 class="uk-h3">
              <span data-uk-icon="icon: commenting;ratio: 1.5"></span>
              Pressemeldungen
            </h3>
          </div>
          <div>
            <router-link
              :to="{ name: 'press-edit' }"
              class="uk-button uk-button-primary"
            >
              <span uk-icon="plus-circle"></span>
              Pressemeldung erstellen
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="uk-grid" data-uk-grid>
      <div class="uk-width-1-1">
        <div class="uk-card uk-card-default uk-card-small">
          <div class="uk-card-body">
            <table class="uk-table uk-table-hover uk-table-divider">
              <thead>
                <tr>
                  <th class="uk-table-expand uk-margin-left"><span class="uk-margin-left">Titel</span></th>
                  <th class="uk-table-shrink uk-text-center">Status</th>
                  <th class="uk-width-small"></th>
                </tr>
              </thead>
              <draggable handle=".handle" v-model="pressReleases" ghost-class="ghost" @end="onEnd" tag="tbody">
                <!--<transition-group type="transition" name="flip-list">-->
                  <tr class="sortable uk-visible-toggle" :id="element.id" v-for="element in pressReleases" :key="element.id">
                    <td>
                      <span
                      class="handle uk-invisible-hover uk-margin-small-right"
                      uk-icon="icon: grid"
                    ></span>
                      <router-link
                      class="uk-link-reset"
                        :to="{ name: 'press-edit', params: { id: element.id } }"
                        >{{ element.title }}
                      </router-link>
                    </td>
                    <td>
                      <div class="uk-text-center">
                      <span
                      v-if="element.active"
                      uk-icon="check"
                      class="uk-text-success uk-icon"
                    ></span>
                    <span
                      v-else
                      uk-icon="ban"
                      class="uk-text-danger uk-icon"
                    ></span>
                      </div>
                    </td>
                    <td>
                       <div
                    class="uk-width-small uk-text-right uk-margin-small-right"
                  >
                    <a href="#" class="uk-icon-link" uk-icon="more"></a>
                    <div
                      uk-dropdown="mode: click;animation: uk-animation-slide-top-small;offset: 5;pos:bottom-right"
                    >
                      <ul class="uk-nav uk-dropdown-nav uk-text-left">
                        <li>
                          <router-link
                            :to="{
                              name: 'press-edit',
                              params: { id: element.id }
                            }"
                          >
                            Bearbeiten
                          </router-link>
                        </li>
                        <li>
                          <a
                            class="uk-text-danger uk-icon"
                            href="#"
                            @click.prevent="remove(element.id)"
                            >Löschen</a
                          >
                        </li>
                      </ul>
                    </div>
                       </div>
                    </td>
                    
                  </tr>
                <!--</transition-group>-->
              </draggable>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageService from '@/services/page.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { mapGetters, mapActions } from 'vuex'
import { DraggableTree } from 'vue-draggable-nested-tree'
import draggable from 'vuedraggable'
export default {
  components: {
    Tree: DraggableTree,
    draggable
  },
  data() {
    return {
      //
    }
  },
  mounted() {
    this.$store.dispatch('press/getList')
  },

  computed: {
    pressReleases: {
        get() {
            return this.$store.state.press.pressReleases
        },
        set(value) {
          this.$store.commit('press/setPressReleases', value)
          PageService.reorderPressReleases(value).then(
            response => {
              this.$store.dispatch('press/getList')
            }
          )
        }
    }
  },

  methods: {
    ...mapActions({
      getList: 'press/getList'
    }),
    onEnd() {

    },
    getTriggerEl(nodeVm) {
      return nodeVm.$el.querySelector('.drag-trigger')
    },
    treeChange(node, targetTree) {
      PageService.reorderPressReleases(targetTree.getPureData()).then(
        response => {
          this.$store.dispatch('press/getList')
        }
      )
    },
    remove(post) {
      const $this = this
      this.$uikit.modal
        .confirm('<strong>Beitrag wirklich löschen?</strong></p>', {
          labels: {
            cancel: 'Abrechen',
            ok: 'Löschen'
          }
        })
        .then(
          function() {
            PageService.deleteBlogPost(post).then(response => {
              $this.getList()
              iziToast.success({
                title: 'OK',
                message: 'Beitrag gelöscht!',
                timeout: 3000,
                position: 'topRight',
                transitionIn: 'fadeInLeft'
              })
            })
          },
          function() {
            //
          }
        )
    }
  }
}
</script>
<style lang="scss">
  .sortable-drag {
    /*opacity: 0;*/
  }
  
  .ghost {
    border: 1px dashed #0088F8 !important;
    box-sizing: border-box;
    background: rgba(0, 136, 249, 0.09);
    color: #0088f9;
    padding: 0;
    opacity: 0;
  }

  .handle {
    cursor: move;
  }
</style>